/**
 * Runtime mocks are disabled unless a developer explicitly opts in.
 *
 * Keeping this check in a function (instead of a module-level constant) also
 * makes the behaviour deterministic in tests that temporarily change the env.
 */
export const areRuntimeMocksEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_MOCKS === 'true';
